import Lucene from 'services/lucene';
import Utils from 'services/utils';

export default class AdvancedSearchController {
    /** @ngInject */
    constructor(Loader, ThingsApi, EventEmitter, $timeout) {
        this.Loader = Loader;
        this.ThingsApi = ThingsApi;
        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.advancedSearchBuckets = {};
        this.isProcessing = false;
        this.hasBuckets = false;

        this.query = '';

        this.labels = [];
        this.notes = [];
        this.folders = [];

        this.resetSearchSettings();
    }

    resetSearchSettings() {
        this.thingName = true;
        this.thingOwner = true;
        this.thingStatus = true;
        this.thingStarred = true;
        this.thingHasPicture = true;
        this.thingType = true;
        this.thingBattery = true;
        this.thingSignal = true;
        this.thingRegistered = true;
        this.thingUpdated = true;
        this.thingLocation = true;
        this.thingLabels = true;
        this.thingNotes = true;
        this.thingFolders = true;
    }

    onThingNameUpdate({ value }) {
        this.thingName = value;
    }

    onThingOwnerUpdate({ value }) {
        this.thingOwner = value;
    }

    onThingStatusUpdate({ value }) {
        this.thingStatus = value;
    }

    onThingStarredUpdate({ value }) {
        this.thingStarred = !value;
    }

    onThingHasPictureUpdate({ value }) {
        this.thingHasPicture = !value;
    }

    onThingTypeUpdate({ value }) {
        this.thingType = value;
    }

    onThingBatteryUpdate({ value }) {
        this.thingBattery = value;
    }

    onThingSignalUpdate({ value }) {
        this.thingSignal = value;
    }

    onThingRegisteredUpdate({ value }) {
        this.thingRegistered = value;
    }

    onThingUpdatedUpdate({ value }) {
        this.thingUpdated = value;
    }

    onThingLocationUpdate({ value }) {
        this.thingLocation = value;
    }

    onThingLabelsUpdate({ value }) {
        this.thingLabels = value;
    }

    onThingNotesUpdate({ value }) {
        this.thingNotes = value;
    }

    onThingFoldersUpdate({ value }) {
        this.thingFolders = value;
    }

    setItemInAdvancedSearchBucket({ item }) {
        Utils.createPath(this.advancedSearchBuckets, item.name, item.value);
        this.hasBuckets = true;

        this.query = Lucene.convertToString(this.advancedSearchBuckets);

        return this.advancedSearchBuckets;
    }

    removeItemFromAdvancedSearchBucket({ item }) {
        if (!Object.keys(this.advancedSearchBuckets).length) return this.advancedSearchBuckets;

        Utils.crawlObjectByPath(this.advancedSearchBuckets, item.name, true);

        this.hasBuckets = Object.keys(this.advancedSearchBuckets).length > 0;

        this.query = Lucene.convertToString(this.advancedSearchBuckets);

        return this.advancedSearchBuckets;
    }

    onSearch() {
        if (!Object.keys(this.advancedSearchBuckets).length || this.isProcessing || !this.query.length) {
            return;
        }

        // this.startProcessing();
        //
        // this.ThingsApi
        //     .search(this.query)
        //     .then(
        //         (data) => {
        this.triggerSearchResult();
            //         this.stopProcessing();
            //     },
            //     this.stopProcessing.bind(this)
            // );
    }

    triggerSearchResult() {
        this.onSearchResult(
            this.eventEmitter({
                query: this.query
            })
        );
    }

    startProcessing() {
        this.isProcessing = true;
        this.Loader.show();
    }

    stopProcessing() {
        // TODO: We use timeout here to visualize progress, if progress is fast no visual component will be visible
        // (it will actually blink), but we don't won't blink :)
        this.$timeout(() => {
            this.isProcessing = false;
            this.Loader.hide();
        }, 500);
    }

    onReset() {
        this.resetSearchSettings();

        this.advancedSearchBuckets = {};
        this.hasBuckets = false;
        this.query = '';

        this.triggerSearchResult();
    }

    close() {
        this.onCloseSideNav();
    }

    triggerSaveView({ view }) {
        this.onSaveView(this.eventEmitter({ view }));
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/search.controller.js